export default "__VITE_ASSET__33cd5650__"